import store from '@/store';

import { decryptWithPrivateKey } from './P2PHelper';
import { handleNewP2Pkeys } from './createP2PKeys';
import { encryptServerKeyHandler } from './encryptServerKeyHandler';
import { getUUID } from './getUuid';
import { fetchP2PWhiteList } from './p2pApis';
import { sendP2PSocketData } from './p2pConnection';

const processFailureCall = (rejected: boolean = false, source) => {
    sendP2PSocketData({
        command: 'send_msg',
        data: {
            client_event: 'not_auth',
            rejected: rejected,
        },
    });
    if (rejected) {
        setTimeout(() => {
            sendP2PSocketData({
                command: 'disconnect_peer',
                data: source,
            });
        }, 500);
    }
};

export const checkUserValidity = async (
    dataRec: {
        user_id: string;
        uuid: string;
        sign: string;
        encrypted_key: string;
    },
    source: string,
) => {
    const uuidStore = await getUUID();
    const myKeys = uuidStore[0].keypair;
    const { privateKeyStringified } = await handleNewP2Pkeys(myKeys);

    const decryptedUserHash = await decryptWithPrivateKey(
        dataRec.sign,
        privateKeyStringified,
    );

    const decryptedUserId = await decryptWithPrivateKey(
        dataRec.user_id,
        privateKeyStringified,
    );
    const decryptedUUid = await decryptWithPrivateKey(
        dataRec.uuid,
        privateKeyStringified,
    );

    const { response } = await fetchP2PWhiteList();

    if (response.length === 0) {
        return setTimeout(() => {
            processFailureCall(false, source);
        }, 500);
    }

    const activeServer = store.getState().serverDataReducer.activeServer;
    const membersList =
        store.getState().serverDataReducer.memberList?.[activeServer];

    const isMemberOfServer = membersList?.[decryptedUserId];

    if (isMemberOfServer) {
        const userDevicesList = response.filter(
            item => item.user_id === decryptedUserId,
        );

        if (userDevicesList && userDevicesList.length > 0) {
            let isAuthMember = false;
            let isRejected = false;
            for (let i = 0; i < userDevicesList.length; i++) {
                const doesHashMatch =
                    userDevicesList[i].hash_signed.sign === decryptedUserHash;
                const doesDeviceMatch =
                    userDevicesList[i].device_signed === decryptedUUid;
                if (
                    doesHashMatch &&
                    doesDeviceMatch &&
                    userDevicesList[i].rejected === 0
                ) {
                    isAuthMember = true;
                    break;
                } else if (
                    doesHashMatch &&
                    doesDeviceMatch &&
                    userDevicesList[i].rejected === 1
                ) {
                    isRejected = true;
                    isAuthMember = true;
                    break;
                }
            }
            if (isAuthMember === true && !isRejected) {
                setTimeout(() => {
                    encryptServerKeyHandler(dataRec, source);
                }, 500);
            } else if (!isAuthMember && isRejected) {
                processFailureCall(true, source);
            } else {
                processFailureCall(false, source);
            }
        } else {
            setTimeout(() => {
                processFailureCall(false, source);
            }, 500);
        }
    } else {
        console.warn('not member of the server ');
    }
};
